<template>
  <div class="header-container">
    <div class="por_container u-relative">
      <div class="header-title u-flex u-row-center">
        <el-image v-if="_showLogo" style="width: 64px;" :src="require(`@/assets/images/logo_${pageName}-white.png`)" fit="contain" alt="logo" />
        <div class="header-title-text u-m-l-16" :style="{'font-size': titleSize}">{{ _headTitle + title }}</div>
        <el-image v-if="_showLogo" style="width: 180px;" :src="require(`@/assets/images/${_img}.png`)" fit="contain" alt="logo" />
      </div>
      <div v-if="_isLogin" class="logout" @click="handleLogout">退出登录<i class="icon fa fa-sign-out u-m-l-4"></i></div>
    </div>
    <div v-if="_showBtn && showLinkbtn" class="btn u-flex" @click="handleClick">
      <slot name="linkbtn"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Message, MessageBox } from 'element-ui';
import applicationList from '@/assets/contants/applicationList';
export default {
  props: {
    showLinkbtn: {
      type: Boolean,
      default: true
    },
    pageName: {
      type: String,
      default: 'mastery'
    },
    title: {
      type: String,
      default: ''
    },
    titleSize: {
      type: String,
      default: '20px'
    }
  },
  data () {
    return {
      pagesGroup: applicationList.pagesGroup
    }
  },
  computed: {
    _headTitle() {
      return this.pagesGroup.find(item => item.value === this.pageName).label;
    },
    _img() {
      return this.pagesGroup.find(item => item.value === this.pageName).img;
    },
    _showBtn() {
      return this.$route.meta.childNode ? false : true;
    },
    _showLogo() {
      const unshowPage = ['manage', 'scale'];
      return unshowPage.indexOf(this.pageName) === -1;
    },
    ...mapGetters('personOptions', ['_isLogin'])
  },
  methods: {
    handleClick() {
      if (this._isLogin) {
        this.$emit('handleHeadLink');
      } else {
        this.$router.push('/login?from=' + this.pageName);
      }
    },
    handleLogout() {
      this.$confirm('确定退出登录?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: "帐号退出中,请稍后!",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        await this.$store.dispatch('personOptions/setResetState');
        setTimeout(() => {
          loading.close();
          if (this.pageName === 'manage') {
            this.$router.push('/supplierAllBack')
          } else {
            this.$router.push('/' + this.pageName);
          }
        }, 500);
      }).catch(() => {});
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  width: 100%;
  height: var(--head-height);
  background: center/cover url('@/assets/images/bg/head.jpg') no-repeat;
  color: #fff;
  position: relative;

  .header-title {
    height: 100%;

    &-text {
      font-weight: bold;
    }
  }

  .btn {
    padding: 6px 18px;
    font-size: 16px;
    border: 2px solid #fff;
    border-right: none;
    border-radius: 15px 0 0 15px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .logout {
    cursor: pointer;
    position: absolute;
    right: 0;
    bottom: 20px;
  }
}
</style>